import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import intersect from '@alpinejs/intersect';
import persist from '@alpinejs/persist';
import Components from 'components';
import Plugins from 'plugins';
import Lity from 'lity';

// Initialise Alpine
window.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.plugin(intersect);
Alpine.plugin(persist);
Alpine.start();

import 'blocks/OTHEDistributors';

jQuery(function ($) {
    Components.init();
    Plugins.init();

    $('a[data-lity]').on('click', function (e) {
        e.preventDefault();
    });

    if ($('.s-wrapper').length) {
        $(document).on('click', ':not(.clickable).s-slide', function (e) {
            let $track = $(this).parent().closest('.s-track');
            if($track.hasClass('no-click')) {
                return;
            }

            let $active = $track.find('.s-slide[data-active]').first().index();
            let $current = $(this).index();

            if ($active > $current) {
                let $diff = $active - $current;
                for (let i = 0; i < $diff; i++) {
                    prevSlide($(this).parent().closest('.s-slider'))
                }
            } else if ($active < $current) {
                let $diff = $current - $active;
                for (let i = 0; i < $diff; i++) {
                    nextSlide($(this).parent().closest('.s-slider'))
                }
            }
        });

        $(document).on('click', '.s-dot', function () {
            let $active = $(this).closest('.s-wrapper').find('.s-slide[data-active]').first().attr('data-index') - 1;
            let $current = $(this).index();
            let $count = $(this).closest('.s-wrapper').find('.s-dot').length;

            if ($active < 0) $active = $count - 1;

            if ($active > $current) {
                let $diff = $active - $current;
                for (let i = 0; i < $diff; i++) {
                    prevSlide($(this).closest('.s-wrapper').find('.s-slider').first())
                }
            } else if ($active < $current) {
                let $diff = $current - $active;
                for (let i = 0; i < $diff; i++) {
                    nextSlide($(this).closest('.s-wrapper').find('.s-slider').first())
                }
            }
        });


        $(document).on('click', '.s-prev', function () {
            prevSlide($(this).parent().closest('.s-wrapper'));
        });

        $(document).on('click', '.s-next', function () {
            nextSlide($(this).parent().closest('.s-wrapper'));
        });

        var startX, endX;
        var isDragging = false;
        var swipeThreshold = 30;

        $(document).on('touchstart', '.s-slider', function (e) {
            startX = e.touches[0].clientX;
        });

        $(document).on('touchmove', '.s-slider', function (e) {
            endX = e.touches[0].clientX;
        });

        $(document).on('touchend', '.s-slider', function (e) {
            let $track = $(this).find('.s-track');

            if ($(window).width() >= 768 && !$track.hasClass('no-click')) {
                if (startX - endX > swipeThreshold) {
                    $(this).parent().closest('.s-wrapper').find('.s-next').trigger('click');
                } else if (endX - startX > swipeThreshold) {
                    $(this).parent().closest('.s-wrapper').find('.s-prev').trigger('click');
                }
            }
        });

        $(document).on('mousedown', '.s-slider', function (e) {
            startX = e.clientX;
            isDragging = true;
        });

        $(document).on('mousemove', '.s-slider', function (e) {
            if (isDragging) {
                endX = e.clientX;
            }
        });

        $(document).on('mouseup', '.s-slider', function (e) {
            let $track = $(this).find('.s-track');
   
            if (isDragging && !$track.hasClass('no-click')) {
                isDragging = false;
                if (startX - endX > swipeThreshold) {
                    $(this).parent().closest('.s-wrapper').find('.s-next').trigger('click');
                } else if (endX - startX > swipeThreshold) {
                    $(this).parent().closest('.s-wrapper').find('.s-prev').trigger('click');
                }
            }
        });
    }

    //show001 - alt slider
    function removeAdditionalActiveSlideClass() {
        $('.show001-alt .slick-slider .slick-slide.slick-active + .slick-slide.slick-active').removeClass('slick-active');
    }
    removeAdditionalActiveSlideClass();
    if ($('.show001-alt').length) {
        $('.show001-alt .slick-slider').on('afterChange', function (event, slick, currentSlide) {
            removeAdditionalActiveSlideClass();
        });
    }

});

function nextSlide($slider) {
    let $track = $slider.find('.s-track');
    let $last = $track.find('.s-slide').last();
    let $first = $track.find('.s-slide').first();
    let $active = $track.find('.s-slide[data-active]');
    if ($active.next().length) {
        $active.next().attr('data-active', 1);
    } else {
        $last.attr('data-active', 1);
    }
    $active.removeAttr('data-active')//.attr('data-prev', 1);
    //track.find('.s-slide[data-prev]').removeAttr('data-prev');

    if (!$first.hasClass('active')) {
        let $index = $first.attr('data-index');
        let $html = '<li class="s-slide" data-index="' + $index + '">' + $first.html() + '</li>';

        $first.remove();
        $track.append($html);
    }
}

function prevSlide($slider) {
    let $track = $slider.find('.s-track');
    let $last = $track.find('.s-slide').last();
    let $first = $track.find('.s-slide').first();
    let $active = $track.find('.s-slide[data-active]');
    if ($active.prev().length) {
        $active.prev().attr('data-active', 1);
    } else {
        $last.prev('data-active', 1);
    }
    $active.removeAttr('data-active')//.attr('data-prev', 1);
    //$track.find('.s-slide[data-prev]').removeAttr('data-prev');

    if (!$last.hasClass('active')) {
        let $index = $last.attr('data-index');
        let $html = '<li class="s-slide" data-prev data-index="' + $index + '">' + $last.html() + '</li>';

        $last.remove();
        $track.prepend($html);
    }
}

// -- Vanilla JS
// -- START SPLITLINES : CN
class SplitLines {
    // Split lines is a custom vanilla JS
    // class that splits the text content
    constructor(obj) {
        if(!obj.element) {
            this.error('No Element Provided');
        }
        this.obj = obj;
    }

    splitLines = (containers) => {
        Array.prototype.forEach.call(containers, (elem) => {
            // ORIGIONAL Script:
                // let split = elem.innerText.split("\n");
                // let result = split.map((splitString) => {
                //     return '<span class="new-line">' + splitString + "</span>";
                // });
            
                // elem.innerHTML = result.join(" ");


            // MODIFIED Script:
            // to handle additional HTML Tags
            let placeholder = '###BR###';
            let htmlContent = elem.innerHTML.replace(/<br\s*\/?>/gi, placeholder);

            let split = htmlContent.split(placeholder);
            let result = split.map((splitString) => {
                return '<span class="new-line">' + splitString.trim() + "</span>";
            });

            // Join the parts back together with <br> tags between them
            elem.innerHTML = result.join('<br>');
        });

        return true;
    }

    init = () => {
        const containers = document.querySelectorAll(this.obj.element);

        if(!containers || containers.length === 0) {
            this.error('No Element Provided');
        }

        this.splitLines(containers);
    }

    error = (message) => {
        console.error(message);
        return false;
    }
}

const splitLines = new SplitLines({'element': '.split-lines'}).init();
// -- END SPLITLINES




const runFormChanges = () => {
    setInterval(() => {
        document.querySelectorAll('.gform_body').forEach((gForm) => {
            let totalField = gForm.querySelector('.input-total-field input');
            
            if(!totalField) { return }
            let totalValidationContainer = gForm.querySelector('.input-total-validation');
            let totalValidation = gForm.querySelector('.input-total-validation input');
            totalValidationContainer.classList.add('hidden');
            
            if(totalField.value === totalValidation.value) {
                return;
            }

            totalValidation.value = totalField.value.replace(/,/g, '');

        });
    }, 400);
}

runFormChanges();